<template>
  <div>
    <b-col
      cols="12"
      class="mb-1"
    >
      <b-link
        style="font-size: 26px; color: #fff;"
        to="/vms-total"
      >
        <feather-icon
          style="margin-bottom: 5px;"
          size="34"
          icon="ArrowLeftIcon"
        /><span style="color: #00FF80;"> ป้าย Reverse: </span>{{ wayname }}
      </b-link>
    </b-col>

    <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 610px; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <b-row>
        <b-col
          lg="12"
          md="12"
        >
          <l-map
            ref="mymap"
            :zoom="zoom"
            :center="center"
            :options="{scrollWheelZoom:false, zoomControl: true, attributionControl:false}"
          >
            <l-tile-layer :url="url" />
            <l-marker
              v-for="(marker, index) in markers"
              :key="'marker'+index"
              :ref="'marker'+index"
              :lat-lng="[marker.latitude, marker.longitude]"
              :options="{ autoClose: false, closeOnClick: false }"
              @click="getInfoCount(marker.wid, marker.wayid, marker.detail, marker.way)"
            >
              <l-icon
                :icon-size="[28, 40]"
                :icon-anchor="[16, 37]"
                :icon-url="require('@/assets/images/icons/markervmsg.png')"
              />
              <l-popup
                ref="popup"
              >
                <div>
                  <span style="font-size: 17px; color:#fff;">ป้าย Reverse</span>
                  <b-table
                    class="table table-borderless"
                    style="background-color: hsl(0, 0%, 0%, 0); font-size: 14px;"
                    responsive="lg"
                    :items="itemsCount"
                    :fields="fields"
                    small
                    stacked
                    foot-clone
                  >
                    <!-- <template #cell(connect)="data">
                        <b-badge
                          :variant="connect[1][data.value]"
                          style="font-size: 13px;"
                        >
                          {{ connect[0][data.value] }}
                        </b-badge>
                      </template> -->
                    <template
                      #cell(wid)="data"
                      colspan="2"
                    >
                      <a :href="`/reverse-detail?wid=${data.item.wid}`">
                        <b-button
                          id="toggle-btn"
                          variant="success"
                        >
                          <span>ดูเพิ่มเติม</span>
                        </b-button>
                      </a>
                    </template>
                  </b-table>
                </div>
              </l-popup>
            </l-marker>
          </l-map>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
/* eslint-disable global-require */
// import Hls from 'hls.js'
import {
  BRow, BCol, BTable, BButton, BLink, BCard,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LIcon, LPopup,
} from 'vue2-leaflet'
import axios from '@axios'
import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-fullscreen/dist/leaflet.fullscreen.css'
import 'leaflet-fullscreen/dist/Leaflet.fullscreen'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */
export default {
  components: {
    BRow,
    BCol,
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LPopup,
    BTable,
    BButton,
    BLink,
    BCard,
  },
  data() {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 12,
      center: [0, 0],
      waydetail: '',
      wayname: '',
      markers: [],
      video: '',
      check: false,
      camdesc: '',
      userData: JSON.parse(localStorage.getItem('userData')),
      itemsCount: [],
      fields: [
        { key: 'detail', label: 'จุดติดตั้ง:', class: 'text-center' },
        { key: 'WayID', label: 'สายทาง:', class: 'text-center' },
        { key: 'wid', label: '', class: 'text-center' },
      ],
      type_name: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getMarkerCount()
  },
  mounted() {
    this.interval = setInterval(() => {
      this.getMarkerCount()
    }, 1000)
    const map = this.$refs.mymap.mapObject
    map.addControl(new window.L.Control.Fullscreen())
  },
  methods: {
    getMarkerCount() {
      axios
        .post('/getMarkerReverseSub', { DeptID: this.$route.query.DeptID })
        .then(response => {
          this.zoom = response.data[0].mapzoom_master
          this.center = []
          this.center.push(response.data[0].latitude)
          this.center.push(response.data[0].longitude)
          this.waydetail = response.data[0].detail
          this.markers = response.data
          this.wayname = response.data[0].DeptName2
          this.type_name = response.data[0].type_name
          this.$nextTick(() => {
            this.fitMapToBounds()
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    getInfoCount(wid, wayid, detail, way) {
      this.itemsCount = []
      this.itemsCount.push({
        wid,
        wayid,
        detail,
        way,
      })
    },
    fitMapToBounds() {
      if (!this.markers || this.markers.length === 0) {
        console.log('No markers to fit bounds')
        return
      }

      console.log(`Fitting map to bounds for ${this.markers.length} markers`)

      const map = this.$refs.mymap.mapObject

      // ตรวจสอบว่ามี markers ที่มีพิกัดถูกต้องหรือไม่
      const validMarkers = this.markers.filter(marker => marker.latitude && marker.longitude
        && !Number.isNaN(marker.latitude) && !Number.isNaN(marker.longitude))

      console.log(`Found ${validMarkers.length} valid markers with coordinates`)

      if (validMarkers.length === 0) {
        console.log('No valid markers with coordinates')
        return
      }

      // หาค่า min/max ของพิกัด lat/lng
      const lats = validMarkers.map(m => parseFloat(m.latitude))
      const lngs = validMarkers.map(m => parseFloat(m.longitude))

      const minLat = Math.min(...lats)
      const maxLat = Math.max(...lats)
      const minLng = Math.min(...lngs)
      const maxLng = Math.max(...lngs)

      console.log(`Bounds: ${minLat},${minLng} to ${maxLat},${maxLng}`)

      // สร้าง bounds จากค่า min/max
      const southWest = window.L.latLng(minLat, minLng)
      const northEast = window.L.latLng(maxLat, maxLng)
      const bounds = window.L.latLngBounds(southWest, northEast)

      // ปรับ zoom และ center ให้เหมาะสมกับ bounds
      map.fitBounds(bounds, {
        padding: [100, 100], // เพิ่ม padding รอบ bounds
        maxZoom: 15, // จำกัด zoom สูงสุด
        animate: true, // ใช้ animation
        duration: 1, // ระยะเวลาของ animation
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  .vue2leaflet-map {
      &.leaflet-container{
      width: 100%;
      height: 568px;
      }
  }
  .leaflet-popup-content {
    margin: 10px 10px;
    width: 250px;
    height: 100%;
  }
  .leaflet-container a.leaflet-popup-close-button {
    padding: 0 0 0 0
  }
  .leaflet-popup-content-wrapper,
.leaflet-popup-tip {
    background: rgba(36, 36, 36, 0.85);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
    /* Green */
    border: 1px solid #00B058;
    border-radius: 12px 12px 12px 12px;
}

</style>
